import {
  FETCH_ERROR,
  FETCH_START,
  FETCH_SUCCESS,
  SHOW_MESSAGE,
} from "../../shared/constants/ActionTypes";
import jwtAxios from "@crema/services/auth/jwt-auth/jwt-api";

// Action to add a new shipping zone
export const addShippingZone = (values, closeModal, form) => {
  return (dispatch) => {
    dispatch({ type: FETCH_START });
    jwtAxios
      .post("/shippingZones/add-shippingzone", values)
      .then((data) => {
        if (data.status === 200) {
          dispatch({ type: FETCH_SUCCESS });
          dispatch({
            type: SHOW_MESSAGE,
            payload: "Shipping zone added successfully.",
          });
          closeModal();
          form.resetFields();
          dispatch(getShippingZones()); // Refresh the list after adding
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: "Something went wrong, Please try again!",
          });
        }
      })
      .catch((error) => {
        dispatch({
          type: FETCH_ERROR,
          payload: error.response?.data?.msg
            ? error.response?.data?.msg
            : error.message,
        });
      });
  };
};

// Action to get all shipping zones
export const getShippingZones = () => {
  return (dispatch) => {
    dispatch({ type: FETCH_START });
    jwtAxios
      .get("/shippingZones/list-shippingzone")
      .then((response) => {
        console.log('API Response:', response);
        if (response.status === 200) {
          dispatch({ type: FETCH_SUCCESS });
          dispatch({
            type: GET_SHIPPING_ZONES,
            payload: response.data,
          });
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: "Something went wrong, Please try again!",
          });
        }
      })
      .catch((error) => {
        console.error('API Error:', error);
        dispatch({
          type: FETCH_ERROR,
          payload: error.response?.data?.msg
            ? error.response?.data?.msg
            : error.message,
        });
      });
  };
};

export const updateShippingZone = (id, formData, closeModal) => {
  return (dispatch) => {
    dispatch({ type: FETCH_START });
    jwtAxios
      .put(`/shippingZones/update-shippingzone/${id}`, formData)
      .then((response) => {
        console.log('Update API Response:', response);
        if (response.status === 200) {
          dispatch({ type: FETCH_SUCCESS });
          dispatch({
            type: SHOW_MESSAGE,
            payload: "Shipping zone updated successfully.",
          });
          closeModal && closeModal();
          dispatch(getShippingZones());
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: "Something went wrong, Please try again!",
          });
        }
      })
      .catch((error) => {
        console.error('Update API Error:', error);
        dispatch({
          type: FETCH_ERROR,
          payload: error.response?.data?.msg
            ? error.response?.data?.msg
            : error.message,
        });
      });
  };
};

export const deleteShippingZone = (id) => {
  return (dispatch) => {
    dispatch({ type: FETCH_START });
    jwtAxios
      .delete(`/shippingZones/delete-shippingzone/${id}`)
      .then((response) => {
        console.log('Delete API Response:', response);
        if (response.status === 200) {
          dispatch({ type: FETCH_SUCCESS });
          dispatch({
            type: SHOW_MESSAGE,
            payload: "Shipping zone deleted successfully.",
          });
          dispatch(getShippingZones());
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: "Something went wrong, Please try again!",
          });
        }
      })
      .catch((error) => {
        console.error('Delete API Error:', error);
        dispatch({
          type: FETCH_ERROR,
          payload: error.response?.data?.msg
            ? error.response?.data?.msg
            : error.message,
        });
      });
  };
};

// Action Types
export const GET_SHIPPING_ZONES = 'GET_SHIPPING_ZONES';
